import axios from 'axios'
import store from '@/store/index'
import { ElMessage, ElLoading } from 'element-plus'
import Router from '@/router/index'
import signlar from '@/utils/signlar'
//import qs from "qs";

let isRefreshing = false;
// 创建一个axios实例
const instance = axios.create({
    baseURL: '/api',
    timeout: 60000,
})
// 存储请求的数组
let cacheRequestArr = [];

// 将所有的请求都push到数组中,其实数组是[function(token){}, function(token){},...]
function cacheRequestArrHandle(cb) {
    cacheRequestArr.push(cb);
}
// 数组中的请求得到新的token之后自执行，用新的token去重新发起请求
function afreshRequest(token) {
    cacheRequestArr.map(cb => cb(token));
}
// 请求拦截
instance.interceptors.request.use(
    function (config) {
        store.commit('getToken')
        let token = store.state.user.token
        if (token != null && token.length > 0)
            config.headers['Authorization'] = 'Bearer ' + token;
        // if (config.method == 'get') {
        //     config.paramsSerializer = function (params) {
        //         return qs.stringify(params, { arrayFormat: 'repeat' })
        //     }
        // }
        return config;
    },
    function (error) {
        console.log(error);
        ElMessage.error({ message: "系统繁忙,请稍后在试", duration: 1500 });
        return Promise.reject(error);
    }
);

// 响应拦截
instance.interceptors.response.use(
    function (response) {
        if (response.request.responseType === 'blob')
            return response;
        return response.data;
    },
    function (error) {
        // 服务器返回的headers
        let headers = error.response.headers;
        var isLogin = error.config.url.indexOf("Login") > -1;
        if (!isLogin) {
            if ((error.response.status == 401 || error.response.status == 403) && headers["jwtauthenticationfailed"] == undefined) {
                ElLoading.service({ fullscreen: true }).close();
                store.commit('clearToken')
                if (error.response.status == 401) ElMessage.warning({ message: "身份已过期,请重新登录", duration: 1500 });
                else ElMessage.warning({ message: error.response.data, duration: 1500 });
                setTimeout(() => {
                    Router.push({ name: "Login" });
                }, 1000);
                signlar.leaveGroup() //断开连接
                localStorage.removeItem("containerWH")
                localStorage.removeItem('examIndex')
                localStorage.removeItem('examId')
                localStorage.removeItem('expandedItemsIndex')
                localStorage.removeItem('unfoldData')
                return;
            }
            else if (error.response.status == 401 && headers["jwtauthenticationfailed"] == "pastDue") {
                var errConfig = error.config;
                store.commit('getToken');
                let refreshToken = store.state.user.refreshToken;
                if (!isRefreshing) {
                    isRefreshing = true;
                    instance({
                        method: 'post',
                        url: "/Business/UserLogin/RefreshToken",
                        params: {
                            refreshToken: refreshToken
                        }
                    }).then(function (res) {
                        if (res.code == 1) {
                            var tokenObj = {
                                token: res.result.token,
                                refreshToken: res.result.refreshToken,
                            };
                            store.commit("setToken", tokenObj);
                            errConfig.headers.Authorization = 'Bearer ' + res.result.token;
                            afreshRequest(res.result.token);
                            cacheRequestArr = [];
                        } else {
                            ElLoading.service({ fullscreen: true }).close();
                            store.commit('clearToken')
                            ElMessage.warning({ message: "身份已过期,请重新登录", duration: 1500 });
                            setTimeout(() => {
                                Router.push({ name: "Login" });
                            }, 1000);
                            signlar.leaveGroup() //断开连接
                            localStorage.removeItem("containerWH")
                            localStorage.removeItem('examIndex')
                            localStorage.removeItem('examId')
                            localStorage.removeItem('expandedItemsIndex')
                            localStorage.removeItem('unfoldData')
                        }
                    }).catch(function (err) {
                        ElLoading.service({ fullscreen: true }).close();
                        store.commit('clearToken')
                        ElMessage.warning({ message: "身份已过期,请重新登录", duration: 1500 });
                        setTimeout(() => {
                            Router.push({ name: "Login" });
                        }, 1000);
                        signlar.leaveGroup() //断开连接
                        localStorage.removeItem("containerWH")
                        localStorage.removeItem('examIndex')
                        localStorage.removeItem('examId')
                        localStorage.removeItem('expandedItemsIndex')
                        localStorage.removeItem('unfoldData')
                        return Promise.reject(err);
                    }).finally(function () {
                        isRefreshing = false;
                    })
                }
                return new Promise((resolve, reject) => {
                    cacheRequestArrHandle(function (token) {
                        errConfig.headers.Authorization = 'Bearer ' + token;
                        //将请求挂起
                        instance.request(errConfig).then(res => {
                            resolve(res)
                        })
                    })
                });
            }
            else {
                ElLoading.service({ fullscreen: true }).close();
                ElMessage.warning({ message: "服务异常，请稍后重试", duration: 1500 });
                // store.commit('getUserInfo')
                // var roleType = store.state.user.userInfo.roleType
                // if (roleType == 1) Router.push({ name: "Error" });
                // else if (roleType == 2 || roleType == 12) Router.push({ name: "PaperError" });
                // else if (roleType == 13 || roleType == 17 || roleType == 16) Router.push({ name: "ExamMarkerError" });
                // else Router.push({ name: "ArbitrationMarkerError" });
            }
        }
    }
);

export default { instance }